import React from 'react';
export let Breakpoint;

(function (Breakpoint) {
  Breakpoint["PHONE"] = "PHONE";
  Breakpoint["TABLET"] = "TABLET";
  Breakpoint["DESKTOP"] = "DESKTOP";
  Breakpoint["WIDE"] = "WIDE";
})(Breakpoint || (Breakpoint = {}));

export const breakpoints = {
  [Breakpoint.PHONE]: 320,
  [Breakpoint.TABLET]: 768,
  [Breakpoint.DESKTOP]: 1024,
  [Breakpoint.WIDE]: 1440
};
export const calculateBreakpoint = width => {
  if (width < breakpoints[Breakpoint.TABLET]) {
    return Breakpoint.PHONE;
  }

  if (width < breakpoints[Breakpoint.DESKTOP]) {
    return Breakpoint.TABLET;
  }

  if (width < breakpoints[Breakpoint.WIDE]) {
    return Breakpoint.DESKTOP;
  }

  return Breakpoint.WIDE;
};
export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = React.useState(calculateBreakpoint(window.innerWidth));
  const handleResize = React.useCallback(() => {
    const newBreakpoint = calculateBreakpoint(window.innerWidth);

    if (breakpoint !== newBreakpoint) {
      setBreakpoint(newBreakpoint);
    }
  }, [breakpoint]);
  React.useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);
  return breakpoint;
};